import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    DisclosureExampleService,
    DisclosureExampleServiceImpl,
} from './services/disclosure-example-service';

export const disclosureContainer = new ContainerModule((bind) => {
    bind(DisclosureExampleService).to(DisclosureExampleServiceImpl);
});
